import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { format } from 'date-fns';

const MiniProfile = ({ conversation, name, avatarUrl }) => {
  if (!conversation) return null;

  const formatCreationDate = (dateString) => {
    try {
      return format(new Date(dateString), 'MMM d, yyyy');
    } catch (error) {
      return null;
    }
  };

  const displayName = name || conversation.name || 'Conversation';
  const avatar = avatarUrl || conversation.avatar || null;
  const creationDate = conversation.createdAt ? formatCreationDate(conversation.createdAt) : null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        py: 2.5,
        px: 2,
        mb: 1.5,
        width: '100%',
      }}
    >
      <Avatar
        src={avatar}
        alt={displayName}
        sx={{ width: 96, height: 96, mb: 1.5, bgcolor: avatar ? undefined : '#007AFF' }}
      >
        {displayName?.[0]?.toUpperCase()}
      </Avatar>

      <Typography sx={{ fontSize: '1.25rem', fontWeight: 600, mb: 0.25 }} >
        {displayName}
      </Typography>

      {creationDate && (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          Created {creationDate}
        </Typography>
      )}
    </Box>
  );
};

export default MiniProfile;
